import { howDoYouKnowUsValues } from '@asgard/api-common';
import { EMAIL_REGEX } from '@asgard/utils';
import { FormSelectOption } from 'components/form/FormSelect/FormSelect.types';
import { z } from 'zod';
import { ContactFormFields } from './ContactForm.types';

const I18N_PREFIX = 'contact:contact';

export const DEFAULT_TYPE_OPTION: FormSelectOption = {
  label: 'SELECT_ONE',
  value: ''
};

// Base schema (used for typing)
export const ContactFormFieldsSchema = z.object({
  name: z.string(),
  email: z.string(),
  description: z.string(),
  company: z.string(),
  howDoYouKnowUs: z.enum(howDoYouKnowUsValues),
  contactPhone: z.string().optional().default(''),
  terms: z.boolean(),
  isSubscribeToNewsletter: z.boolean().optional().default(false)
});

// Validation schema (strict)
export const ContactFormFieldsValidationSchema = ContactFormFieldsSchema.extend(
  {
    // Name required
    name: z.string().nonempty({
      message: `${I18N_PREFIX}.form.required-name`
    }),

    // Email required, format
    email: z
      .string()
      .nonempty({
        message: `${I18N_PREFIX}.form.required-email`
      })
      .regex(EMAIL_REGEX, {
        message: `${I18N_PREFIX}.form.invalid-email`
      }),

    // Description required
    description: z.string().nonempty({
      message: `${I18N_PREFIX}.form.required-description`
    }),

    // How do you know us required
    howDoYouKnowUs: z.enum(howDoYouKnowUsValues, {
      errorMap: () => ({
        message: `${I18N_PREFIX}.form.required-how-do-you-know-us`
      })
    }),

    // company required
    company: z.string().nonempty({
      message: `${I18N_PREFIX}.form.required-company`
    })
  }
);

export const FORM_FIELDS_DEFAULT_VALUES: Partial<ContactFormFields> = {
  name: '',
  email: '',
  description: '',
  company: '',
  contactPhone: '',
  howDoYouKnowUs: undefined,
  isSubscribeToNewsletter: false
};
